module.exports = __webpack_public_path__ + "img/Union.d1360fbc.svg";